import { useEffect } from 'react'
import type { RefObject } from 'react'

export default function useOutsideAlerter(
  ref: RefObject<HTMLElement>,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  cb: () => void = () => {},
  isListen = true,
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        cb()
      }
    }
    if (isListen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    // Bind the event listener
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, cb, isListen])
}
